




















































































































































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';
import { exportFiles, exportPostFiles, formatUrl} from '../common/util';
import config from '../config/index';
import {mapState, mapActions} from 'vuex';
import store from '../store/store';
import { Form } from 'element-ui';
import {
  TaskData
} from '../types/common';
import { CheckInfoData, CheckFile } from '../types/checkInfo';

export default Vue.extend({
  name: 'CheckResult',
  data(): CheckInfoData {
    return {
      timer: null,
      reportCheckType: '',
      onlineReportUrl: '',
      isShowLineReportType: false,
      onlineReportId: '',
      reportTypeString: '',
      downReportType: '',
      listLoading: false,
      accountList: [],
      firstLevelList: [],
      secondLevelList:[],
      thirdLevelList:[],
      isUpload: [],
      firstLevel: '',
      secondLevel:'',
      thirdLevel:'',
      pageObj: {
        total: 100,
        pageIndex: 1,
        pageSize: 10
      },
      pageSizeList: [10, 20, 50, 100],
      isShowReportType: false,
      isShowOneReportType: false,
      isShowFixReportType: false,
      reportType: 0,
      pickerOption: {
        disabledDate(time: Date) {
          return time.getTime() > Date.now();
        }
      },
      isSearchSimple: true,
      isShowOrder: false,
      isShowMark: false,
      searchData: {
        checkUserId: '', //检测账户
        colloge: '',
        department: '',
        major: '',
        startper:'', // 开始相似比
        endper: '', // 结束相似比
        starttime: '', // 开始检测时间
        endtime: '', // 结束检测时间
        checkType: '', // 检测类型
        author: '', // 作者
        studentnumber: '', // 学号
        tutor: '', // 导师
        title: '', // 题名/文件夹
        status: 'ALL', // 检测状态
        mark: '', // 标记
        taskid: '', // 文件夹id
        taskName: '',
        offset: 0, // 分页偏移量
        limit: 10, // 分页大小
        OrderBy: '1', // 排序
        isSearchSubAccount: false, // 是否是子账户检测查询
        subUserId: '', // 子账户id
        isExcelExport: 0,
        listType: ''
      },
      selectCheckResultList: [],
      checkIds: [],
      checkTypes:[],
      taskList: [],
      isAddFolder: false,
      copyCheckResultList: [],
      isShowForm: false,
      $refs: {
        form: Form
      },
      form: {
        newTask: '',
        taskId: '',
        taskName: ''
      },
      rules: {
        taskName: [{
          required: true,
          validator: async (rule: any, value: any, callback: any) => {
            if (value === '') {
              callback(new Error('请输入文件夹名称'));
            } else if (value.length > 50) {
              callback(new Error('文件夹名称不能大于50位'));
            } else if (await (this as any).checkTaskName()) {
              callback(new Error('该文件夹已存在'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        taskId: [{
          required: true,
          validator: (rule: any, value: any, callback: any) => {
            if (value === '') {
              callback(new Error('请选择文件夹'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      }
    };
  },
  computed: mapState({
    userInfo: (state: any) => store.getters.getUserInfo,
    tableHeader: (state: any) => store.getters.getTableHeader,
    checkResultList: (state: any) => store.getters.getCheckResult
  }),
  watch: {
   
  },
  methods: {
    changevSearchData(id: string){
     this.searchData.taskid = id;
    }, 
     // 下载原文
    downloadPaper() {
      if (this.checkIds.length === 0) {
        this.$alert(' 请至少选择一条检测信息！', '提示');
        return false;
      }
      if (this.checkIds.length === 1) {
        this.downloadPaperSingle(this.checkIds[0]);
      } else {
        const isUpload = _.every(this.isUpload, (item: any) => {
          return item === '1';
        });
        if(!isUpload) {
          this.$alert(' 选中的论文中存在没有全文的论文，请重新选择！', '提示');
          return false;
        }
      this.$confirm('是否确认下载原文？', '提示', { type: 'warning' }).then(() => {
        this.$store.dispatch('setLoading', {
          isShow: true
        });
        // end
        this.$http.post('/api/DetectResult/DownloadPaper', {
          checkIds: this.checkIds
          }, {
            responseType: 'blob'
        }).then((res: any) => {
          this.$store.dispatch('setLoading', {
            isShow: false
          });
          let headerFileName = res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1];
          headerFileName = decodeURIComponent(headerFileName);
          exportPostFiles(res.data, headerFileName);
        }).catch(() => {
          this.$store.dispatch('setLoading', {
            isShow: false
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });







        // this.$http.post('/api/DetectResult/DownloadPaper', {
        //   checkIds: this.checkIds
        // }, {
        //   responseType: 'blob'
        // }).then((res: any) => {
        //   let headerFileName = res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1];
        //   headerFileName = decodeURIComponent(headerFileName);
        //   // post导出方法
        //   exportPostFiles(res.data, headerFileName);
        // })
      }

    },
    // 单篇原文下载
    downloadPaperSingle(row: any) {
      if(row.uploadType === "WFSearch") {
        window.open(row.wfUrl);
        return ;
      }
      if(row.isUpload === "0"){
        return;
      }
      const isUpload = _.every(this.isUpload, (item: any) => {
          return item === '1';
        });
        if(!isUpload) {
          this.$alert(' 选中的论文中存在没有全文的论文，请重新选择！', '提示');
          return false;
        }
      this.$confirm('是否确认下载原文？', '提示', { type: 'warning' }).then(() => {
        this.$store.dispatch('setLoading', {
          isShow: true
        });
        // end
        this.$http.post('/api/DetectResult/DownloadPaper', {
          checkId: row.checkId || row
          }, {
            responseType: 'blob'
        }).then((res: any) => {
          this.$store.dispatch('setLoading', {
            isShow: false
          });
          let headerFileName = res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1];
          headerFileName = decodeURIComponent(headerFileName);
          exportPostFiles(res.data, headerFileName);
        }).catch(() => {
          this.$store.dispatch('setLoading', {
            isShow: false
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 校验查询条件是否正确
    checkSearchData() {
      if (this.searchData.startper && !(/^[0-9]+[\.]?[0-9]*$/.test(this.searchData.startper)) || this.searchData.endper && !(/^[0-9]+[\.]?[0-9]*$/.test(this.searchData.endper))) {
        this.$alert(' 请输入正确相似比！', '提示');
        return false;
      }
      if (this.searchData.startper > 100 || this.searchData.endper > 100) {
        this.$alert(' 相似比不能大于100！', '提示');
        return false;
      }
      if (this.searchData.startper && this.searchData.endper && (parseFloat(this.searchData.startper) > parseFloat(this.searchData.endper))) {
        this.$alert(' 最小相似比不能大于最大相似比！', '提示');
        return false;
      }
      if (this.searchData.starttime > this.searchData.endtime) {
        this.$alert(' 开始时间不能大于结束时间！', '提示');
        return false;
      }
      return true;
    },
    // 查询类型变化
    changeSearchType() {
      // const isSearchSimple = this.isSearchSimple;
      this.isSearchSimple = !this.isSearchSimple;
      // 记录用户操作
      // localStorage.setItem('isSearchSimple', isSearchSimple.toString());
      let scrollTop = 300;
      if (this.isSearchSimple) {
        scrollTop = 300;
      } else {
        scrollTop = 520;
      }
      this.$store.dispatch('setTableHeader', {
        scrollTop
      });
    },
    // 检测时间发生变化时触发
    changeTime() {
      // 日期转成字符串比较
      // this.searchData.beginTime = new Date(this.searchData.beginTime).toJSON();
      // this.searchData.endTime = new Date(this.searchData.endTime).toJSON();
    },
    // 排序变化触发
    changeOrder(order: string) {
      // end
      this.searchData.OrderBy = order;
      this.getCheckResult();
    },
    // 设置检测时间
    setCheckTime(num: any, type: string) {
      this.searchData.endtime = moment(new Date()).format('YYYY-MM-DD');
      this.searchData.starttime = moment(this.searchData.endtime).subtract(num, type).format('YYYY-MM-DD');
      this.getCheckResult();
    },
    // 获取文件夹列表
    getTaskList() {
      this.$http.get('/api/TaskManage/GetTaskDropdownList').then((data: any) => {
        this.taskList = data.data;
      });
    },
    // 清空查询条件
    clear() {
      this.searchData = {
        checkUserId: '', //检测账户
        colloge: '',
        department: '',
        major: '',
        listType: '',
        isExcelExport: 0,
        startper: '', // 开始相似比
        endper: '', // 结束相似比
        endtime: moment().format('YYYY-MM-DD'), // 开始检测时间
        starttime: moment().format('YYYY-MM-DD'), // 开始检测时间
        checkType: '', // 检测类型
        author: '', // 作者
        title: '', // 题名/文件夹
        studentnumber: '',
        tutor: '',
        status: 'ALL', // 检测状态
        mark: '', // 标记
        taskid: '', // 文件夹id
        taskName: '',
        offset: 0, // 分页偏移量
        limit: 10, // 分页大小
        OrderBy: '1', // 排序
        isSearchSubAccount: false, // 是否是子账户检测查询
        subUserId: '' // 子账户id
      };

      // this.searchData.endtime = moment().format('YYYY-MM-DD');
      this.searchData.starttime = moment(this.searchData.endtime).subtract(7, 'day').format('YYYY-MM-DD');
      this.getCheckResult();
    },
    // 获取检测结果
    getCheckResult(i?:boolean) {
      if(i)this.searchData.offset = 0;
      const isCanSearch = this.checkSearchData();
      if (!isCanSearch) {
        return false;
      }
      this.listLoading = true;
      this.$http.get('/api/DetectResult/GetCheckList', {
        params: this.searchData
      }).then((data: any) => {
        this.$store.dispatch('setCheckResult', data.data.data);
        this.pageObj.total = data.data.total;
        this.$nextTick(() => {
          this.listLoading = false;
          this.initFixTable();
        });
      });
    },
    // 查看在线报告
    getOnLineReportLink(row: any) {
      this.$http.get('/api/DetectResult/GetOnLineReportLink').then((data: any) => {
        if(row.checkType === "一对一检测"){
          window.open(`${data.data}reportweb/?reportId=${row.checkId}&productId=HDYD&checkType=OneByOne`, '_blank');
        }else if (row.checkDBType === 'SelfDB') {
          window.open(`${data.data}reportweb/?reportId=${row.checkId}&productId=HD&reportType=originalText&checkType=SelfDB`, '_blank');
        }else {
          window.open(`${data.data}reportweb/?reportId=${row.checkId}&productId=HD&reportType=originalText`, '_blank');
        }
      })
    },
    // 显示隐藏在线报告
    showLineReportType(val: boolean, itemRow: any) {
      if (val) {
        this.isShowLineReportType = val;
        if (itemRow && itemRow.checkState !== 'Success') {
          this.$alert('只有检测成功文献才可以下载，请重新选择！', '提示');
            return false;
        }
        this.onlineReportId = itemRow.checkId;
      } else {
        this.isShowLineReportType = false;
      }
    },
    // 导出
    exportCheckResult() {
     // end
      const isCanSearch = this.checkSearchData();
      if (!isCanSearch) {
        return false;
      }
      this.searchData.isExcelExport = 1
      exportFiles(formatUrl(this.searchData, `${config.api}/api/DetectResult/GetCheckList`));
      this.searchData.isExcelExport = 0;
    },
    
    toggleSelection(rows: CheckFile[]) {
      if (rows.length) {
        rows.forEach(row => {
          this.$refs.checkResultList.toggleRowSelection(row);
        });
      } else {
        this.$refs.checkResultList.clearSelection();
      }
    },
    // 选择、取消上传文件钩子方法
    handleSelectionChange(val: CheckFile[]) {
      this.selectCheckResultList = val;
      this.checkIds = [];
      this.checkTypes = [];
      this.isUpload = [];
      _.forEach(this.selectCheckResultList, (value: CheckFile) => {
        this.checkIds.push(value.checkId);
        this.checkTypes.push(value.checkType);
        this.isUpload.push(value.isUpload);
        // 同步两个列表状态
        (this.$refs.copyList as any).toggleRowSelection(value, true);
        (this.$refs.checkResultList as any).toggleRowSelection(value, true);
      });
      // 同步两个列表状态
      if (this.checkIds.length === 0) {
        (this.$refs.copyList as any).clearSelection();
        (this.$refs.checkResultList as any).clearSelection();
      }
    },
    // 显示/隐藏选择报告类型
    showReportType(val: boolean, itemRow: any) {
      if (!val) {
        this.isShowReportType = val;
        this.isShowOneReportType = val;
        this.downReportType = '';
        return;
      }
      if (!itemRow || !itemRow.checkId) {
        if (this.checkIds.length === 0 ) {
          this.$alert(' 请至少选择一条检测信息！', '提示');
          return false;
        }
      } else {
        this.downReportType = itemRow.checkId;
      }
      // if (val && this.checkIds.length > 50) {
      //   this.$alert(' 检测报告文件较大，建议每次下载报告不超过50篇 ', '提示');
      //   return false;
      // }
      const isCanDownload = _.some(this.selectCheckResultList, (item: CheckFile) => {
        return item.checkState !== 'Success';
      });
      if (isCanDownload ) {
        this.$alert('只有检测成功文献才可以下载，请重新选择！', '提示');
        return false;
      }
      if (itemRow && itemRow.checkState !== 'Success') {
         this.$alert('只有检测成功文献才可以下载，请重新选择！', '提示');
          return false;
      }

      const checkConstrast = _.every(this.selectCheckResultList, (item: CheckFile) => {
        return item.checkType === '比对库检测';
      });
      const checkOneToOne = _.every(this.selectCheckResultList, (item: CheckFile) => {
        return item.checkType === '一对一检测';
      });
      if (checkConstrast || (itemRow && itemRow.checkType) === '比对库检测') {
        this.reportCheckType  = 'WFDB';
        this.isShowReportType = val;
      } else if(checkOneToOne || (itemRow && itemRow.checkType) === '一对一检测') {
        // this.$alert('系统暂不支持一对一检测类型报告下载，可点击相似比在线查看检测报告', '提示');
        //   return false;
        this.reportCheckType  = 'OneByOne';
        this.isShowOneReportType = val;
      } else {
        this.$alert('您选中的检测信息包含比对库检测和一对一检测类型，两种检测类型提供的检测报告不同，建议同检测类型批量下载！', '提示');
          return false;
      }
    },
    // 改变添加文件夹表单状态
    changeFormState(state: boolean) {
      if (this.checkIds.length === 0 && state) {
        this.$alert(' 请至少选择一条检测信息！', '提示');
        return false;
      }
      // if (this.taskList.length === 0 && state) {
      //   this.$alert('暂无文件夹，您可在文件夹管理页面进行创建', '提示');
      //   return false;
      // }
      if (!state) {
        this.$refs.form.resetFields();
      }
      this.isShowForm = state;
    },
    // 改变文件夹类型事件
    changeFolderType() {
      this.$refs.form.resetFields();
    },
    // 已有文件夹change事件
    changeTask(id: string) {
      let obj: TaskData | any = {};
      obj = this.taskList.find((item: TaskData) => {
        return item.taskId === id;
      });
      this.form.taskName = obj && obj.taskName || '';
    },
    // 检测文件夹名称是否存在
    async checkTaskName() {
      return this.$http.get(`/api/TaskManage/IsExistTask/`, {
         params: this.form
      }).then((data: any) => data.data);
    },
    // 创建文件夹
    createFolder() {
      // end
      this.$http.post(`/api/TaskManage/CreateTask`, {
        taskName: this.form.taskName
      }).then(async (data: any) => {
        const result = data.data;
        Object.assign(this.form, {
          taskId: result.taskId,
          taskName: result.taskName
        });
        this.isAddFolder = true;
        await this.getTaskList();
        this.setInTask();
      }).catch(() => {
        this.$store.dispatch('setLoading', {
          isShow: false
        });
      });
    },
    // 添加至文件夹
    intoFolder() {
      this.$refs.form.validate((valid: any) => {
        if (valid) {
          this.$store.dispatch('setLoading', {
            isShow: true
          });
          if (!this.isAddFolder) {
            this.createFolder();
          } else {
            this.setInTask();
          }
        }
      });
    },
    // 添加至文件夹
    setInTask() { 
      this.$refs.form.validate((valid: any) => {
        if (valid) {
          Object.assign(this.form, {
            checkIds: this.checkIds
          });
         // end DetectResult/UpdateTask
          this.$http.put('/api/DetectResult/UpdateTask', this.form).then((res: any) => {
            this.$store.dispatch('setLoading', {
              isShow: false
            });
            this.$message({
              message: `添加成功`,
              type: 'success'
            });
            this.getCheckResult();
            this.changeFormState(false);
          }).catch(() => {
            this.$store.dispatch('setLoading', {
              isShow: false
            });
          });
        }
      });
    },
    // 删除选中文件
    delFileList() {
      if (this.checkIds.length === 0) {
        this.$alert(' 请至少选择一条检测信息！', '提示');
        return false;
      }
      this.$confirm('检测信息删除后将无法恢复，是否确认删除？', '提示', { type: 'warning' }).then(() => {
        this.$store.dispatch('setLoading', {
          isShow: true
        });
        // end
        this.$http.delete('/api/HDCheck/DeleteCheck', {
          data: {
            checkIds: this.checkIds
          }
        }).then((data: any) => {
          this.$store.dispatch('setLoading', {
            isShow: false
          });
          this.handleSelectionChange([]);
          this.getCheckResult();
          this.$message({
            message: `删除成功`,
            type: 'success'
          });
        }).catch(() => {
          this.$store.dispatch('setLoading', {
            isShow: false
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 重新检测
    reCheck(checkId?: string) {
      if (!checkId) {
        if (this.checkIds.length === 0) {
          this.$alert(' 请至少选择一条检测信息！', '提示');
          return false;
        }
        const isCanReCheck = _.some(this.selectCheckResultList, (item: CheckFile) => {
          return item.checkState === 'Success' || item.checkState === 'Checking';
        });
       
        const isCheckTypeOne = _.every(this.selectCheckResultList, (item: CheckFile) => {
          return item.checkType === '一对一检测';
        });
        const isCheckTypeCon = _.every(this.selectCheckResultList, (item: CheckFile) => {
          return item.checkType === '比对库检测';
        });
        if (!isCheckTypeOne && !isCheckTypeCon) {
          this.$alert('您选中的检测类型中存在类型为一对一检测和比对库检测的，请重新选择后再开始检测！', '提示');
          return false;
        }
        if (isCanReCheck) {
          this.$alert('您选中的检测信息中存在状态为等待检测或检测成功的，请重新选择后再开始检测！', '提示');
          return false;
        }
        this.$store.dispatch('setLoading', {
          isShow: true,
          text: '正在重检...'
        });
        let CheckDBType = ''
        if (this.checkTypes[0] === '一对一检测') {
          CheckDBType = 'OneByOne'
        } else {
          CheckDBType = 'WFDB';     
        }
        this.$http.post('/api/HDCheck/RecheckList', {
          checkIds: this.checkIds,
          CheckDBType: CheckDBType
        }).then((res: any) => {
          this.$store.dispatch('setLoading', {
            isShow: false,
            text: '正在加载...'
          });
          this.$message({
            message: `重检成功`,
            type: 'success'
          });
          this.getCheckResult();
        }).catch(() => {
          this.$store.dispatch('setLoading', {
            isShow: false,
            text: '正在加载...'
          });
        });
      } else {
        this.$http.post('/api/Check/ReCheck', {
          checkIds: [checkId]
        }).then((res: any) => {
          this.$message({
            message: `重检成功`,
            type: 'success'
          });
          this.getCheckResult();
        });
      }
    },
    // 标记/取消问题文献
    signPaper(mark: boolean) {
      if (this.checkIds.length === 0) {
        this.$alert(' 请至少选择一条检测信息！', '提示');
        return false;
      }
      const params = Object.assign({
        ismark: mark
      }, {
        checkIds: this.checkIds
      });
      // end
      this.$http.put('/api/DetectResult/DoMark', params).then((res: any) => {
        this.$message({
          message: `操作成功`,
          type: 'success'
        });
        this.getCheckResult();
        this.isShowMark = false;
      });
    },
    numberFormatStr(reportType: number){
      switch (reportType) {
        case 0:
          this.reportTypeString = 'simple';
          break;
        case 1:
          this.reportTypeString = 'detailPart';
          break;
        case 2:
          this.reportTypeString = 'originalText';
          break;
        default:
          this.reportTypeString = 'simple';
          break;
      }
    },
    // 下载报告(批量)
    downloadReport() {
      this.numberFormatStr(this.reportType);
      if (!this.downReportType) {
        this.$http.post('/api/DetectResult/DownloadReports', {
          CheckIds: this.checkIds,
          ReportType: this.reportTypeString,
          CheckType: this.reportCheckType
        }, {
          responseType: 'blob'
        }).then((res: any) => {
          let fileName = '';
          let checkType = '';
          let headerFileName = res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1];
          headerFileName = decodeURIComponent(headerFileName);
          if (this.reportCheckType === 'OneByOne'){
            checkType = '一对一检测';
          } else {
            checkType = '比对库检测';
          }
          checkType = moment().format('YYYYMMDDHHmmss');
          switch (this.reportType) {
            case 0:
              fileName = checkType + '论文相似性检测简明报告.zip';
              break;
            case 1:
              fileName = checkType + '论文相似性检测详细片段报告.zip';
              break;
            case 2:
              fileName = checkType + '论文相似性检测原文标注报告.zip';
              break;
            case 4:
              fileName = checkType + '论文相似性检测一对一报告.zip';
              break;
            default:
              fileName = checkType + '论文相似性检测原文标注报告.zip';
              break;
          }
          if (headerFileName) {
          fileName = headerFileName;
          }
  
          // post导出方法
          exportPostFiles(res.data, fileName);
        });
        this.isShowReportType = false;
      } else {
        let row = {checkId: this.checkIds[0], checkType: this.reportCheckType,ReportType: this.reportTypeString,};
        this.downloadReportSingle(row);
      }
      this.isShowOneReportType = false;
      this.$alert('正在下载报告，请稍等！', '提示');
    },
    // 下载报告(单篇)
    downloadReportSingle(row: any) {
      if (row.checkType === '比对库检测') {
        this.reportCheckType  = 'WFDB';
      } else if(row.checkType === '一对一检测') {
        // this.$alert('系统暂不支持一对一检测类型报告下载，可点击相似比在线查看检测报告', '提示');
        //   return false;
        this.reportCheckType  = 'OneByOne';
      }
      let params = {
        checkId: row.checkId,
        checkType: this.reportCheckType
      }
      exportFiles(formatUrl( params, `${config.api}/api/DetectResult/ReportDownload`));
      this.isShowReportType = false;
      this.$alert('正在下载报告，请稍等！', '提示');
    },
    // 改变分页size
    handleSizeChange(val: number) {
      this.pageObj.pageSize = val;
      this.pageObj.pageIndex = 1;
      this.setSearchPage();
      this.getCheckResult();
    },
    // 改变当前页
    handleCurrentChange(val: number) {
      this.pageObj.pageIndex = val;
      this.setSearchPage();
      this.getCheckResult();
    },
    // 设置分页
    setSearchPage() {
      this.searchData.offset = (this.pageObj.pageIndex - 1) * this.pageObj.pageSize;
      this.searchData.limit = this.pageObj.pageSize;
    },
    // 初始化固定表头
    initFixTable() {
      // 函数节流
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.$refs.fixTableStyle) {
          (this.$refs.fixTableStyle as any).style.width = (this.$refs.tableStyle as any).clientWidth + 'px';
        }
      }, 200);
    }
  },
  mounted() {
    window.onresize = () => {
      this.initFixTable();
    };
    this.$store.dispatch('setTableHeader', {
      scrollTop: 300
    });
    // 获取用户操作
    this.searchData.taskid = decodeURIComponent((this.$route.query as any).taskid || '');
    if (this.searchData.taskid) {
      this.isSearchSimple = false;
    } else {
      this.searchData.endtime = moment().format('YYYY-MM-DD');
      this.searchData.starttime = moment(this.searchData.endtime).subtract(7, 'day').format('YYYY-MM-DD');
    }
    this.getCheckResult();
    this.getTaskList();
  }
});
